import React from 'react';
import PropTypes from 'prop-types';

function makeOnClick(history) {
  function onLinkClick() {
    if (history.location.pathname === '/reset') {
      history.goBack();
    } else {
      history.push('/manage/login');
    }
  }
  return onLinkClick;
}

const BackToSignIn = ({ history }) => (
  <a
    href={history.location.pathname === '/reset' ? '#sign-in' : '/manage/login'}
    className="w-100 db tc mv4 f6 underline blue"
    onClick={makeOnClick(history)}
  >
    Back to Sign In
  </a>
);

BackToSignIn.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export default BackToSignIn;
